import {
  ADD_VEHICLE,
  VEHICLE_ERROR,
  GET_VEHICLES,
  GET_VEHICLE,
} from "../types";
// import axios from "axios";
import customAxios from "../../utils/customAxios";

// get vehicle by id
export const getVehicle = (id) => async (dispatch) => {
  try {
    const res = await customAxios.get(`/api/admin/vehicles/${id}`);
    dispatch({
      type: GET_VEHICLE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: VEHICLE_ERROR,
      payload: { msg: err.response, status: err.response },
    });
  }
};

// get vehicles
export const getVehicles = () => async (dispatch) => {
  try {
    const res = await customAxios.get("/api/admin/vehicles");
    dispatch({
      type: GET_VEHICLES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: VEHICLE_ERROR,
      payload: { msg: err.response, status: err.response },
    });
  }
};

// get all active vehicles
export const getAllActiveVehicles = async () => {
  try {
    const res = await customAxios.get("/api/admin/vehicles/getallactive");
    return res.data;
  } catch (err) {
    return [];
  }
};

// Creates a vehicle, or overwrites an existing one when `edit` is set.
//
// Resolves to { ok, message }. Both screens confirm behind a dialog and report the
// outcome themselves, so an alert raised from in here would only land behind the
// open dialog; the failure message goes back to the caller instead.
export const addVehicle =
  (formdata, history, edit = false) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await customAxios.post(
        "/api/admin/vehicles",
        formdata,
        config
      );
      dispatch({
        type: ADD_VEHICLE,
        payload: res.data,
      });
      return { ok: true };
    } catch (err) {
      // A network failure or a 500 with an HTML body leaves err.response or its data
      // undefined, and reading .errors straight off it threw inside the catch -- which
      // took out the whole handler, so the screen showed nothing at all.
      const errors = err?.response?.data?.errors;
      const message = errors
        ? `Registration number already exists. ${errors.codeName || ""} ${JSON.stringify(errors.keyValue || {})}`.trim()
        : "Vehicle could not be saved. Please try again.";

      dispatch({
        type: VEHICLE_ERROR,
        payload: { msg: err?.response, status: err?.response },
      });
      return { ok: false, message };
    }
  };
